/* Mount Leaf theme content.
   Shopify supplies each product's live title, price, stock and images. This file adds the
   Ayurvedic content Shopify has no field for: ingredients, how-to steps, routines, kits, quiz,
   herbarium. Products are matched by `handle` (the end of the product's URL).

   To add a product: copy an entry in ML_SEED, set its `handle`, and fill in the fields.
   A product can also override its entry with a JSON metafield `custom.ml_details`.
   Ratings/reviews here are fallbacks; a reviews app's rating metafield takes priority. */

const ML_SEED = [
  {
    "id": "bright-beauty-oil",
    "handle": "bright-beauty-oil",
    "name": "Bright Beauty Oil",
    "tagline": "Ayurvedic night oil for radiant, even-toned skin",
    "category": "skin",
    "type": "Face oil",
    "concerns": [
      "dull-skin",
      "pigmentation",
      "fine-lines"
    ],
    "badge": "Bestseller",
    "rating": 5.0,
    "reviews": 35,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "30 ml",
        "price": 1195,
        "mrp": 1399
      }
    ],
    "images": [
      "bright-beauty-oil-1",
      "bright-beauty-oil-3",
      "bright-beauty-oil-4",
      "bright-beauty-oil-2",
      "bright-beauty-oil-5"
    ],
    "short": "A luxurious herbal night elixir that brightens, nourishes, and rejuvenates your skin naturally while softening fine lines and blemishes.",
    "about": "Bright Beauty Oil is a luxurious herbal blend crafted to brighten, nourish and rejuvenate your skin naturally. Enriched with potent antioxidants and age-defying botanicals, this lightweight, fast-absorbing oil helps reduce early signs of ageing by improving elasticity, softening fine lines and supporting firm, youthful skin. Kashmiri saffron, sandalwood, manjistha, and mulethi in a cold-pressed virgin oil base work overnight on fine lines, blemishes, and uneven tone.",
    "benefits": [
      "Enhances Complexion",
      "Anti-Blemishes",
      "Anti-Wrinkles",
      "Fades Dark Spots",
      "Enriched with Antioxidants"
    ],
    "benefitDetails": [
      {
        "title": "Enhances Complexion",
        "text": "Promotes a brighter, even-toned, and naturally glowing skin with pure saffron and sandalwood."
      },
      {
        "title": "Anti-Blemish Formula",
        "text": "Manjistha and Licorice actively diminish dark spots, hyperpigmentation, and blemishes for clearer skin."
      },
      {
        "title": "Anti-Wrinkles & Elasticity",
        "text": "Nourishes deep dermal layers, softens fine lines, and supports youthful, smooth skin texture."
      },
      {
        "title": "Rich in Antioxidants",
        "text": "A rich botanical blend of antioxidants that protects skin against free radicals and environmental stress."
      },
      {
        "title": "Fast-Absorbing Overnight Repair",
        "text": "Lightweight, non-greasy oil absorbs quickly to let the botanicals repair and rejuvenate while you sleep."
      }
    ],
    "ingredients": [
      {
        "name": "Saffron",
        "hindi": "केसर",
        "local": "Kesar 0.3g",
        "note": "Renowned for its brightening properties. Helps treat pigmentation and enhances natural radiance."
      },
      {
        "name": "Sandalwood",
        "hindi": "चंदन",
        "local": "Chandan 4g",
        "note": "Soothing and anti-inflammatory. Helps keep the complexion calm and balanced."
      },
      {
        "name": "Licorice",
        "hindi": "मुलेठी",
        "local": "Mulethi 4g",
        "note": "Calms the skin, inhibits excess melanin, and helps reduce hyperpigmentation."
      },
      {
        "name": "Manjistha",
        "hindi": "मंजिष्ठा",
        "local": "Rubia cordifolia 3g",
        "note": "Classical anti-blemish herb that promotes clear, healthy skin and addresses uneven tone."
      },
      {
        "name": "Gopi Chandan",
        "hindi": "गोपी चंदन",
        "local": "3g",
        "note": "Traditional sandalwood variety that smooths and purifies the complexion."
      },
      {
        "name": "Ceylon Oak & Dyer’s Oak",
        "hindi": "माजूफल",
        "local": "7g total",
        "note": "Rich in natural tannins that firm lax skin and refine enlarged pores."
      },
      {
        "name": "Laccifer lacca & Symplocos",
        "hindi": "लाक्षा और लोध्र",
        "local": "6g total",
        "note": "Ayurvedic astringents that restore skin tone balance and strengthen elasticity."
      },
      {
        "name": "Quad-Oil Botanical Base",
        "hindi": "तिल, बादाम, नारियल, जैतून",
        "local": "Sesame, Almond, Coconut & Olive Oils (68g)",
        "note": "Nourishing lipid base that replenishes cellular moisture and keeps skin hydrated and supple."
      }
    ],
    "steps": [
      "Cleanse your face thoroughly with a gentle cleanser and pat dry.",
      "Apply a few drops of Bright Beauty Oil to clean skin on your face and neck.",
      "Gently massage with upward circular motions until fully absorbed.",
      "Recommended for night use only to allow the skin to repair and rejuvenate while you sleep."
    ],
    "reviewsList": [
      {
        "name": "Sneha",
        "text": "Glowing, soft skin and better texture within a few weeks."
      },
      {
        "name": "Deepak",
        "text": "Used consistently and saw dark spots fade. Super good smell and no sticky feel."
      },
      {
        "name": "Rahul",
        "text": "Absolutely lovely, makes my skin soft and dewy. Absorbs instantly without leaving an oily layer."
      },
      {
        "name": "Pooja",
        "text": "I have been using this beauty oil for the past few weeks and I am extremely happy with the results. My skin feels deeply nourished, soft, and naturally glowing."
      },
      {
        "name": "Kirti Chaudhary",
        "text": "This oil made my skin smooth and glowing without feeling oily at all."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/bright-beauty-oil.png?v=1791907412"
  },
  {
    "id": "replenishing-face-pack",
    "handle": "replenishing-face-pack",
    "name": "Replenishing Face Pack Cum Scrub",
    "tagline": "Ayurvedic detox, tan-removal & glow face pack & scrub (Abhamukhi)",
    "category": "skin",
    "type": "Face pack",
    "concerns": [
      "tan",
      "dull-skin",
      "oily-skin",
      "pigmentation",
      "acne"
    ],
    "badge": "Bestseller",
    "rating": 5.0,
    "reviews": 13,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "50 g",
        "price": 695,
        "mrp": 850
      }
    ],
    "images": [
      "replenishing-face-pack-1",
      "replenishing-face-pack-3",
      "replenishing-face-pack-2",
      "replenishing-face-pack-4",
      "replenishing-face-pack-5"
    ],
    "short": "Natural face pack that removes tan, cleans the skin, and gently exfoliates dead skin cells for a radiant complexion.",
    "about": "Mount Leaf Replenishing Face Pack is a natural face pack that helps remove tan, cleans the skin, and gently exfoliates dead skin. It clears dirt and excess oil from the skin, brightens the complexion, and makes the face look fresh. After application, the skin feels smooth, clean, and slightly glowing. With regular use, the skin becomes healthier and more radiant.",
    "benefits": [
      "Tan Removal",
      "Exfoliating",
      "Revives Natural Glow",
      "Deep Cleansing",
      "Refines Skin Texture"
    ],
    "benefitDetails": [
      {
        "title": "Tan Removal",
        "text": "Helps lift sun tan and surface hyperpigmentation, restoring an even, natural skin tone."
      },
      {
        "title": "Gentle Exfoliation",
        "text": "Natural barley and red lentils gently remove dead skin cells without micro-tears, leaving skin smooth and soft."
      },
      {
        "title": "Revives Natural Glow",
        "text": "Brings back the skin's natural radiance and makes the face look fresh, luminous, and bright."
      },
      {
        "title": "Deep Dirt & Oil Cleansing",
        "text": "Clears dirt and excess oil from pores, purifying the skin and preventing breakouts."
      }
    ],
    "ingredients": [
      {
        "name": "Barley",
        "hindi": "जौ",
        "local": "Barley 47g",
        "note": "Natural brightening exfoliant rich in azelaic acid to clarify and smooth skin."
      },
      {
        "name": "Chickpeas & Red Lentils",
        "hindi": "बेसन और मसूर दाल",
        "local": "17g total",
        "note": "Traditional Ayurvedic ubtan base that lifts grime, excess sebum, and impurities."
      },
      {
        "name": "Orange Peel",
        "hindi": "संतरे का छिलका",
        "local": "8.5g",
        "note": "High natural Vitamin C content that cuts greasiness and lifts dull tan."
      },
      {
        "name": "Red Sandalwood",
        "hindi": "लाल चंदन",
        "local": "5g",
        "note": "Cooling astringent that soothes inflammation and promotes natural radiance."
      },
      {
        "name": "Turmeric & Yellow Mustard",
        "hindi": "हल्दी और पीली सरसों",
        "local": "5g total",
        "note": "Antiseptic botanicals that detoxify skin and combat blemishes."
      },
      {
        "name": "Manjistha & Onion Seeds",
        "hindi": "मंजिष्ठा और कलौंजी",
        "local": "5g total",
        "note": "Anti-blemish herbs that address pigmentation and refine complexion."
      },
      {
        "name": "Nutgrass & Jatamansi",
        "hindi": "नागरमोथा और जटामांसी",
        "local": "5g total",
        "note": "Balances skin oils, tones pores, and calms irritated skin."
      },
      {
        "name": "Camphor & Rose Flowers",
        "hindi": "कपूर और गुलाब फूल",
        "local": "2g total",
        "note": "Delivers an instant cooling, refreshed sensation and gentle hydration."
      }
    ],
    "steps": [
      "Mix scrub, beauty oil, and curd (or rose water / milk) together to prepare a smooth paste.",
      "After cleansing your face thoroughly, apply this mixture evenly on your face and neck.",
      "Let it dry for 20 minutes.",
      "Gently rub it off with light hands in circular motions, then wash your face with cool water. Use once a week."
    ],
    "reviewsList": [
      {
        "name": "Ankit",
        "text": "I have been using this face pack regularly and the results are clearly visible. My skin feels deeply cleansed, fresh, and naturally glowing after every use."
      },
      {
        "name": "Sneha",
        "text": "I use this face pack twice a week and my skin texture has improved a lot. It removes dullness and gives a healthy glow."
      },
      {
        "name": "Surbhi Sharma",
        "text": "Gentle on the skin and works really well for sun tan."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/replenishing-face-pack.png?v=1791907427"
  },
  {
    "id": "bio-hair-enzyme",
    "handle": "silken-root-mountleaf-glycolic-bright-dark-spot",
    "name": "Sprouting Bio Hair Enzyme",
    "tagline": "Ayurvedic scalp-nourishing enzyme for root activation & growth",
    "category": "hair",
    "type": "Scalp treatment",
    "concerns": [
      "hair-fall",
      "dandruff",
      "dry-scalp"
    ],
    "badge": "Bestseller",
    "hover": "bio-hair-enzyme-4",
    "rating": 4.9,
    "reviews": 121,
    "ratingDist": [
      90,
      10,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "100 ml",
        "price": 1050
      }
    ],
    "images": [
      "bio-hair-enzyme",
      "bio-hair-enzyme-4",
      "bio-hair-enzyme-1",
      "bio-hair-enzyme-5",
      "bio-hair-enzyme-2"
    ],
    "short": "Ayurvedic scalp-nourishing formula designed to activate hair roots, improve scalp health, and support natural hair growth.",
    "about": "Mount Leaf Sprouting Bio Hair Enzyme is an Ayurvedic scalp-nourishing formula designed to activate hair roots, improve scalp health, and support natural hair growth using a blend of traditional, plant-based ingredients. It works by deeply hydrating the scalp, strengthening weakened roots, reducing dryness, and creating a clean, healthy environment for new hair to grow. The lightweight spray absorbs quickly into the scalp, making it easy for daily application without leaving a greasy feel. By nourishing roots, balancing scalp oils, and improving overall hair texture.",
    "benefits": [
      "Improves Hair Growth",
      "Increases Hair Strength",
      "Enhances Shine and Texture",
      "Clears Dandruff & Dryness",
      "Deep Root Nourishment"
    ],
    "benefitDetails": [
      {
        "title": "Improves Hair Growth",
        "text": "Nourishes the roots and supports stronger, faster natural hair growth with active fermented enzymes."
      },
      {
        "title": "Increases Hair Strength",
        "text": "Strengthens weak strands, reduces breakage, and promotes healthier hair right from the roots."
      },
      {
        "title": "Enhances Shine and Texture",
        "text": "Adds natural shine, smoothness, and softness to your hair while improving overall texture."
      },
      {
        "title": "Hydrates & Balances Scalp",
        "text": "Deeply hydrates the scalp, reduces dryness, clears dandruff, and balances scalp oils without greasiness."
      }
    ],
    "ingredients": [
      {
        "name": "Bhringraj (Eclipta alba)",
        "hindi": "भृंगराज",
        "local": "5g",
        "note": "The King of Herbs. Activates hair roots, strengthens weak follicles, and reduces hair fall."
      },
      {
        "name": "Neem (Azadirachta indica)",
        "hindi": "नीम",
        "local": "5g",
        "note": "Antibacterial and antifungal. Eliminates dandruff, clears flakes, and keeps the scalp healthy."
      },
      {
        "name": "Indian Jujube Leaf",
        "hindi": "बेर पत्ता",
        "local": "5g",
        "note": "Hydrates roots, improves elasticity, and conditions hair naturally."
      },
      {
        "name": "Nerium oleander",
        "hindi": "कनेर पत्ता",
        "local": "5g",
        "note": "Traditional scalp balancer that revitalizes dormant follicles and stimulates circulation."
      },
      {
        "name": "Brahmi (Bacopa monnieri)",
        "hindi": "ब्राह्मी",
        "local": "5g",
        "note": "Calms scalp stress, nourishes hair follicles, and promotes thicker density."
      },
      {
        "name": "Jaggery",
        "hindi": "गुड़",
        "local": "5g",
        "note": "Natural humectant that delivers deep botanical hydration and softens hair texture."
      }
    ],
    "steps": [
      "Apply the enzyme directly to the roots of your hair before bedtime.",
      "Gently massage your scalp for 2–3 minutes to boost absorption and stimulate blood circulation.",
      "Leave it on overnight so the nutrients can work deeply on the hair follicles.",
      "In the morning (or on your next hair-wash day), shampoo and condition as usual."
    ],
    "reviewsList": [
      {
        "name": "Ritika",
        "text": "I started using Bio Hair Enzyme because of continuous hair thinning. Within a month, I noticed less hair fall and small new hair growth near the front area. My confidence has improved a lot."
      },
      {
        "name": "Anishika Gupta",
        "text": "I had slight bald patches due to stress. After consistent use, I can see tiny baby hairs growing in that area. It really works if used patiently."
      },
      {
        "name": "Preeti",
        "text": "My main issue was weak roots and breakage. This product nourishes the scalp deeply and makes roots stronger. Best product ever."
      },
      {
        "name": "Sumit Gupta",
        "text": "I was worried before trying a new product, but Bio Hair Enzyme is very gentle on the scalp. No itching, no irritation, just healthy hair growth."
      },
      {
        "name": "Monika",
        "text": "My husband and I both are using this product. It works well for both of us. Hair fall is controlled and hair texture has improved."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/bio-hair-enzyme.png?v=1791907384"
  },
  {
    "id": "velvet-touch-hemp-shampoo",
    "handle": "velvet-touch-hemp-shampoo",
    "name": "Velvet Touch Hemp Shampoo",
    "tagline": "Gentle Cleansing & Frizz Control · Sulfate Free & Paraben Free",
    "category": "hair",
    "type": "Shampoo",
    "concerns": [
      "dry-scalp",
      "hair-fall"
    ],
    "badge": "New",
    "rating": 5.0,
    "reviews": 16,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "200 ml",
        "price": 799,
        "mrp": 999
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/velvet-touch-hemp-shampoo.png?v=1791907436",
    "short": "Mount Leaf Professional salon-grade formula enriched with cold-pressed hemp seed oil for gentle cleansing and frizz control.",
    "about": "Mount Leaf Professional Velvet Touch Hemp Shampoo is an ultra-nourishing, salon-grade Ayurvedic formula enriched with cold-pressed hemp seed oil. Specially crafted for frizz control and intense hair smoothness, it cleanses the scalp gently without stripping natural protective oils.",
    "benefits": [
      "Gentle Cleansing",
      "Frizz Control",
      "Hair Smoothness",
      "Sulfate & Paraben Free",
      "Omega 3 & 6 Enriched"
    ],
    "benefitDetails": [
      {
        "title": "Gentle Cleansing",
        "text": "Cleanses impurities without disturbing scalp natural moisture balance."
      },
      {
        "title": "Frizz Control",
        "text": "Tames flyaways and seals hair cuticles against atmospheric humidity."
      },
      {
        "title": "Hair Smoothness",
        "text": "Infuses botanical lipids for touchably silky, glossy hair."
      },
      {
        "title": "Sulfate & Paraben Free",
        "text": "100% gentle and safe for regular use and color-treated hair."
      }
    ],
    "ingredients": [
      {
        "name": "Hemp Seed Oil",
        "hindi": "भांग बीज तेल",
        "note": "Rich in essential Omega-3, 6 & 9 fatty acids that strengthen hair cuticles and seal in moisture."
      },
      {
        "name": "Amla",
        "hindi": "आंवला",
        "note": "Vitamin C rich powerhouse that fortifies follicles and adds luminous shine."
      },
      {
        "name": "Aloe vera",
        "hindi": "घृतकुमारी",
        "note": "Cools and hydrates the scalp while smoothing hair texture."
      },
      {
        "name": "Bhringraj",
        "hindi": "भृंगराज",
        "note": "Strengthens roots and protects strands against breakage."
      }
    ],
    "steps": [
      "Wet hair thoroughly with water.",
      "Dispense 1-2 pumps onto palms and work into a rich lather.",
      "Massage gently into scalp and lengths for 60 seconds.",
      "Rinse thoroughly with water. Use 2–3 times weekly."
    ],
    "reviewsList": [
      {
        "name": "Simran K.",
        "text": "Finally a sulfate-free shampoo that actually lathers and leaves hair silky without feeling sticky! Loved it."
      },
      {
        "name": "Pooja Verma",
        "text": "Frizz is completely gone after just 2 washes. Super gentle on scalp."
      }
    ]
  },
  {
    "id": "hand-rub",
    "handle": "mountleaf-herbal-hand-rub",
    "name": "Mount Leaf Herbal Hand Rub",
    "tagline": "Tea Constituents & Essential Oil · Cleans 99.9% Germs (CSIR-IHBT)",
    "category": "skin",
    "type": "Hand rub",
    "concerns": [
      "dry-skin"
    ],
    "badge": "CSIR-IHBT",
    "rating": 4.9,
    "reviews": 24,
    "ratingDist": [
      92,
      8,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "100 ml",
        "price": 299,
        "mrp": 399
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/hand-rub.png?v=1791907415",
    "short": "Formulated & researched by CSIR-IHBT as per WHO formulation. Natural tea constituents and essential oils kill 99.9% germs without drying.",
    "about": "Developed in research partnership with CSIR-IHBT (Institute of Himalayan Bioresource Technology), Mount Leaf Herbal Hand Rub combines clinical disinfection with natural Ayurvedic protection. Prepared strictly according to WHO standards, it eliminates 99.9% of bacteria and viruses while leaving hands moisturized, fresh, and free from synthetic fragrances.",
    "benefits": [
      "Cleans 99.9% Germs",
      "CSIR-IHBT Researched",
      "WHO Hygiene Spec",
      "Tea Constituents & Essential Oil",
      "Natural & Hygienic",
      "Non-drying on skin"
    ],
    "benefitDetails": [
      {
        "title": "Cleans 99.9% Germs",
        "text": "Fast-acting antimicrobial protection compliant with WHO formulation."
      },
      {
        "title": "Tea Constituents",
        "text": "High-purity Himalayan tea polyphenols provide natural antioxidant defense."
      },
      {
        "title": "Essential Oils",
        "text": "Pure botanical essential oils impart a fresh natural aroma without artificial perfumes."
      },
      {
        "title": "Non-Drying",
        "text": "Moisturizing formula keeps hands soft and protected through repeated use."
      }
    ],
    "ingredients": [
      {
        "name": "Tea extract",
        "hindi": "चाय सत्व",
        "note": "Natural Himalayan tea polyphenols with proven antimicrobial properties."
      },
      {
        "name": "Essential oils",
        "note": "Pure plant essential oils that refresh skin naturally."
      },
      {
        "name": "Aloe vera",
        "hindi": "घृतकुमारी",
        "note": "Locks in moisture to prevent hand dryness."
      }
    ],
    "steps": [
      "Pump 2–3 ml onto dry hands.",
      "Rub hands together thoroughly covering palms, fingers, and back of hands.",
      "Allow to air dry for 15–20 seconds. No water needed."
    ],
    "reviewsList": [
      {
        "name": "Dr. Rajesh",
        "text": "Excellent hand rub, non-sticky and smells refreshing. Doesn't dry out hands even after multiple uses."
      },
      {
        "name": "Meenakshi",
        "text": "Best sanitizer I have used, natural fragrance and leaves hands soft."
      }
    ]
  },
  {
    "id": "sprouting-hair-oil",
    "handle": "sprouting-hair-oil-ayurvedic-oil-for-hair-growth-thickness",
    "name": "Sprouting Hair Oil",
    "tagline": "Sprouted botanical nectar for deep root strength & natural growth",
    "category": "hair",
    "type": "Hair oil",
    "concerns": [
      "hair-fall",
      "dry-scalp",
      "dandruff"
    ],
    "badge": "Bestseller",
    "rating": 4.9,
    "reviews": 46,
    "ratingDist": [
      92,
      8,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "100 ml",
        "price": 1050
      }
    ],
    "images": [
      "sprouting-hair-oil-3",
      "sprouting-hair-oil",
      "sprouting-hair-oil-2",
      "sprouting-hair-oil-4"
    ],
    "short": "Sprouted herbal hair oil that strengthens roots, controls dandruff and dryness, and restores moisture and shine.",
    "about": "Sprouting Hair Oil is a powerful Ayurvedic hair-nourishing formula prepared through a natural sprouting and fermentation process that enhances the potency of herbs to deeply strengthen the scalp and hair roots. The sprouted herbal actives penetrate deeper into the roots, helping control dandruff, dryness, and itchiness while restoring moisture and shine to dull, lifeless hair. It is suitable for all hair types and ideal for anyone looking for a natural solution to hair thinning, premature greying, and scalp imbalance.",
    "benefits": [
      "Promotes healthy hair growth",
      "Strengthens hair roots",
      "Improves hair texture and shine",
      "Nourishes and conditions hair",
      "Protects from damage and breakage",
      "Helps control dandruff and dryness"
    ],
    "benefitDetails": [
      {
        "title": "Promotes Healthy Hair Growth",
        "text": "Sprouted herbal actives penetrate deeper into the roots to nourish follicles and support sustained, healthy growth."
      },
      {
        "title": "Strengthens Hair Roots",
        "text": "Fortifies weakened hair strands, anchoring roots and minimizing excessive hair fall and thinning."
      },
      {
        "title": "Improves Texture and Shine",
        "text": "Restores essential moisture and glossy shine to dull, lifeless, and rough hair lengths."
      },
      {
        "title": "Controls Dandruff & Itchiness",
        "text": "Soothes irritated scalp skin, eliminates dry flakes, and rebalances natural scalp moisture."
      },
      {
        "title": "Protects from Damage & Breakage",
        "text": "Forms a protective botanical barrier against UV damage, environmental pollution, and mechanical friction."
      }
    ],
    "ingredients": [
      {
        "name": "Coconut Oil",
        "hindi": "नारियल तेल",
        "local": "50g base",
        "note": "Deeply penetrating base oil that conditions strands, seals cuticles, and locks in moisture."
      },
      {
        "name": "Jujube Leaf & Neem Leaf",
        "hindi": "बेर पत्ता और नीम पत्ता",
        "local": "16g total",
        "note": "Hydrates roots, controls dandruff, dryness, and itchiness, and keeps the scalp clean."
      },
      {
        "name": "Bhringraj & Amla",
        "hindi": "भृंगराज और आंवला",
        "local": "4g total",
        "note": "The ultimate Ayurvedic duo for hair sprouting, root strength, and premature greying defence."
      },
      {
        "name": "Haritaki & Bibhitaki",
        "hindi": "हरड़ और बहेड़ा",
        "local": "2g total",
        "note": "Triphala botanicals that cleanse and detoxify the scalp environment."
      },
      {
        "name": "Banyan Roots",
        "hindi": "बरगद जटा",
        "local": "1g",
        "note": "Classical Ayurvedic secret for anchoring loose roots and strengthening hair tensile strength."
      },
      {
        "name": "Brahmi & Jatamansi",
        "hindi": "ब्राह्मी और जटामांसी",
        "local": "2g total",
        "note": "Calms scalp stress, nourishes hair follicles, and promotes thicker density."
      },
      {
        "name": "Nut Grass & Symplocos",
        "hindi": "नागरमोथा और लोध्र",
        "local": "2g total",
        "note": "Balances scalp sebum secretion and tones follicular tissues."
      },
      {
        "name": "Sesame Oil & Manjistha",
        "hindi": "तिल तेल और मंजिष्ठा",
        "local": "Cold-pressed",
        "note": "Nourishing carrier oil with natural UV protection that enhances micro-circulation."
      }
    ],
    "steps": [
      "Warm the oil: Slightly heat the bottle by rubbing it between your hands or placing it in a bowl of warm water.",
      "Apply to scalp and hair: Gently massage the warm oil into your scalp and along your hair, especially focusing on mid-lengths and ends.",
      "Leave it on: Keep the oil on your hair for at least 30 minutes or leave it overnight for deeper nourishment.",
      "Wash and condition: Shampoo and condition your hair as usual. For best results, use three times a week consistently for 8 weeks."
    ],
    "reviewsList": [
      {
        "name": "Pooja Verma",
        "text": "My hair fall reduced significantly after using this oil for 3 weeks. It feels very light and smells natural."
      },
      {
        "name": "Kavita",
        "text": "Amazing oil! Makes hair soft, shiny and curbs dandruff completely without feeling sticky."
      },
      {
        "name": "Amit Sharma",
        "text": "Roots feel stronger and scalp dryness is gone. Excellent Ayurvedic formula."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/sprouting-hair-oil.png?v=1791907429"
  },
  {
    "id": "sprouting-shampoo",
    "handle": "sprouting-shampoo",
    "name": "Sprouting Shampoo",
    "tagline": "Herbal hair cleanser for follicle activation, dandruff control & strength",
    "category": "hair",
    "type": "Shampoo",
    "concerns": [
      "hair-fall",
      "dandruff"
    ],
    "badge": "Bestseller",
    "hover": "product-4",
    "rating": 4.9,
    "reviews": 88,
    "ratingDist": [
      94,
      6,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "300 ml",
        "price": 645
      }
    ],
    "images": [
      "sprouting-shampoo",
      "product-4",
      "product-7",
      "sprouting-shampoo-2"
    ],
    "short": "Premium herbal cleanser crafted with Bhringraj, Amla, Neem, and Shikakai to support hair sprouting and reduce hair fall.",
    "about": "Sprouting Shampoo is a premium herbal hair cleanser crafted to support hair sprouting, reduce hair fall and restore scalp balance. Its powerful blend of Bhringraj, Amla, Neem, Brahmi, Jujube Leaf and fermented herbal enzymes energizes hair follicles, strengthens the roots and activates slow-growing or dormant follicles. The gentle, pH-balanced formula removes dirt, excess oil, dandruff flakes and product buildup without stripping the scalp’s natural moisture.",
    "benefits": [
      "Anti-Dandruff",
      "Prevents Hair Loss",
      "Promotes Healthy Hair Growth",
      "Cleanses Buildup Gently",
      "Adds Softness & Shine"
    ],
    "benefitDetails": [
      {
        "title": "Anti-Dandruff Action",
        "text": "Helps reduce dandruff, clears flakes, and keeps the scalp clean, refreshed, and healthy."
      },
      {
        "title": "Prevents Hair Loss",
        "text": "Strengthens the roots from within and minimizes wash-day hair fall and breakage."
      },
      {
        "title": "Promotes Healthy Hair Growth",
        "text": "Supports stronger, healthier, and more natural hair growth with regular use of fermented botanical enzymes."
      },
      {
        "title": "Gentle Non-Stripping Cleanse",
        "text": "Removes dirt, excess oil, and product buildup without stripping the scalp's natural protective moisture."
      }
    ],
    "ingredients": [
      {
        "name": "Shikakai (Acacia concinna)",
        "hindi": "शिकाकाई",
        "local": "0.03g",
        "note": "Natural herbal cleanser rich in gentle saponins that wash away impurities without drying."
      },
      {
        "name": "Bhringraj (Eclipta alba)",
        "hindi": "भृंगराज",
        "local": "0.03g",
        "note": "Re-energizes roots, curbs excess shedding, and promotes thick healthy hair growth."
      },
      {
        "name": "Amla (Emblica officinalis)",
        "hindi": "आंवला",
        "local": "0.03g",
        "note": "Rich in natural Vitamin C and tannins to strengthen follicles and add luminous shine."
      },
      {
        "name": "Haritaki & Bibhitaki",
        "hindi": "हरड़ और बहेड़ा",
        "local": "0.06g total",
        "note": "Triphala herbs that cleanse scalp buildup, reduce irritation, and condition lengths."
      },
      {
        "name": "Brahmi (Bacopa monnieri)",
        "hindi": "ब्राह्मी",
        "local": "0.03g",
        "note": "Nourishes the scalp barrier and fortifies brittle hair strands against breakage."
      },
      {
        "name": "Indian Costus (Kuth)",
        "hindi": "कुठ",
        "local": "0.03g",
        "note": "Traditional antimicrobial root that balances the scalp and prevents infections."
      },
      {
        "name": "Jatamansi & Fenugreek",
        "hindi": "जटामांसी और मेथी",
        "local": "0.06g total",
        "note": "Supplies plant proteins to smooth frizz, condition lengths, and calm sensitive scalp."
      },
      {
        "name": "Ratanjot (Alkanet root)",
        "hindi": "रतनजोत",
        "local": "0.075g",
        "note": "Natural botanical conditioning agent that protects scalp health and enhances lustrous texture."
      }
    ],
    "steps": [
      "Begin by thoroughly wetting your hair and scalp with water.",
      "Apply shampoo directly to your scalp and roots.",
      "Gently massage for 30 seconds to refresh, cleanse, and activate the roots.",
      "Rinse thoroughly with water. Suitable for regular use."
    ],
    "reviewsList": [
      {
        "name": "Anika",
        "text": "After almost 2 months of consistent use, my hair density looks better. My ponytail feels thicker and healthier."
      },
      {
        "name": "Simran Kaur",
        "text": "It's not a quick fix product, but if you use it consistently for 2–3 weeks, you will see the difference. My hair fall reduced and growth improved."
      },
      {
        "name": "Rahul",
        "text": "My whole family is using this shampoo now. It suits everyone's hair type. Nice packaging and good quantity at this price."
      },
      {
        "name": "Rohit",
        "text": "After using this shampoo, my hair looks shiny and healthy. Even my friends noticed the change and asked which product I'm using."
      },
      {
        "name": "Neha",
        "text": "It cleans the scalp deeply without making hair dry."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/sprouting-shampoo.png?v=1791907433"
  },
  {
    "id": "radiance-cream",
    "handle": "radiance-cream",
    "name": "Radiance Cream",
    "tagline": "Powerful herbal formulation for natural glow, blemish control & wrinkles",
    "category": "skin",
    "forMen": true,
    "type": "Face cream",
    "concerns": [
      "pigmentation",
      "dull-skin",
      "fine-lines"
    ],
    "badge": "Bestseller",
    "hover": "radiance-cream-3",
    "rating": 5.0,
    "reviews": 12,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "20 g",
        "price": 1599
      }
    ],
    "images": [
      "radiance-cream",
      "radiance-cream-3",
      "radiance-cream-5",
      "radiance-cream-2",
      "radiance-cream-4"
    ],
    "short": "Powerful herbal formulation designed to fade blemishes, lighten dark spots, and reduce wrinkles for glowing, youthful skin.",
    "about": "Mount Leaf Radiance Cream is a powerful herbal formulation designed to fade blemishes, lighten dark spots and reduce wrinkles for naturally glowing, youthful skin. Enriched with brightening botanicals and antioxidant-rich ingredients, this nourishing cream works deep within the skin layers to improve texture, even out skin tone and boost firmness.",
    "benefits": [
      "Gives a Natural Glow",
      "Reduces Blemishes",
      "Minimizes Wrinkles",
      "Lightens Dark Circles",
      "Reduces Freckles"
    ],
    "benefitDetails": [
      {
        "title": "Gives a Natural Glow",
        "text": "Makes the face brighter and more radiant with pure saffron, sandalwood, and patang extracts."
      },
      {
        "title": "Reduces Blemishes",
        "text": "Helps fade stubborn spots, acne marks, and uneven pigmentation for clear, uniform skin."
      },
      {
        "title": "Minimizes Wrinkles",
        "text": "Smoothens fine lines and supports youthful-looking skin elasticity and firm bounce."
      },
      {
        "title": "Lightens Dark Circles",
        "text": "Helps reduce under-eye darkness and puffiness for a well-rested, fresh appearance."
      },
      {
        "title": "Reduces Freckles",
        "text": "Lightens freckles and sun spots, improving overall skin tone clarity with daily application."
      }
    ],
    "ingredients": [
      {
        "name": "Saffron (Crocus sativus)",
        "hindi": "केसर",
        "local": "2.5g",
        "note": "Renowned skin-brightening stigma that illuminates complexion and fades dark spots."
      },
      {
        "name": "Symplocos Bark (Lodhra)",
        "hindi": "लोध्र छाल",
        "local": "2.5g",
        "note": "Firms skin, reduces puffiness, and restores balanced elasticity."
      },
      {
        "name": "Turmeric (Haldi)",
        "hindi": "हल्दी",
        "local": "2.5g",
        "note": "Antioxidant and anti-inflammatory. Clarifies skin and defends against blemishes."
      },
      {
        "name": "Sandalwood (Chandan)",
        "hindi": "चंदन",
        "local": "2.5g",
        "note": "Calms the skin, soothes heat and redness, and imparts a natural glow."
      },
      {
        "name": "Manjistha Fruit",
        "hindi": "मंजिष्ठा",
        "local": "2.5g",
        "note": "Purifies dermal layers and helps eliminate hyperpigmentation."
      },
      {
        "name": "Licorice (Mulethi)",
        "hindi": "मुलेठी",
        "local": "2.5g",
        "note": "Natural tyrosinase inhibitor that fades freckles and sun spots."
      },
      {
        "name": "Rose Petals & Mung Bean",
        "hindi": "गुलाब और मूंग",
        "local": "5g total",
        "note": "Hydrates, tones pores, and supplies plant peptides for smooth skin texture."
      },
      {
        "name": "Caesalpinia sappan (Patang)",
        "hindi": "पतंग काष्ठ",
        "local": "2.5g",
        "note": "Improves blood circulation and bestows a healthy, natural rosy glow."
      },
      {
        "name": "Vacha & Yellow Mustard",
        "hindi": "वचा और सरसों",
        "local": "5g total",
        "note": "Stimulates dermal micro-circulation and clarifies blemishes."
      },
      {
        "name": "Sesame Oil Base",
        "hindi": "तिल तेल",
        "local": "2.5g",
        "note": "Nourishing lipid base that ensures deep trans-dermal absorption."
      }
    ],
    "steps": [
      "Take a small amount of cream in your palm.",
      "Rub both palms together to spread it evenly and warm it slightly.",
      "Apply gently to your face and neck with upward circular motions for best absorption.",
      "Use daily, morning and night, for smooth, radiant and youthful skin."
    ],
    "reviewsList": [
      {
        "name": "Nikita",
        "text": "Within a week, I noticed smoother and brighter skin."
      },
      {
        "name": "Bhweta Bhatia",
        "text": "I've been using this cream for a few weeks and my skin feels more nourished and even-toned."
      },
      {
        "name": "Manisha",
        "text": "I love this cream! It leaves my skin soft, bright and nourished."
      },
      {
        "name": "Akansha",
        "text": "Perfect cream for daily skincare, absorbs quickly."
      },
      {
        "name": "Shabnam Sood",
        "text": "Nice cream, highly recommended."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/radiance-cream.png?v=1791907424"
  },
  {
    "id": "prakleen-neem-face-wash",
    "handle": "prakleen-neem-face-wash-natural-acne-blemish-control-for-clear-fresh-skin",
    "name": "Prakleen Neem Face Wash",
    "tagline": "Gentle herbal cleanser for acne purification, oil control & glowing skin",
    "category": "skin",
    "forMen": true,
    "type": "Face wash",
    "concerns": [
      "acne",
      "oily-skin"
    ],
    "badge": "Bestseller",
    "rating": 5.0,
    "reviews": 12,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "150 ml",
        "price": 499
      }
    ],
    "images": [
      "prakleen-neem",
      "prakleen-neem-3",
      "prakleen-neem-2",
      "prakleen-neem-4",
      "prakleen-neem-5"
    ],
    "short": "Gentle herbal cleanser enriched with pure Neem extract, Tulsi and Green Tea to purify skin and control acne without drying.",
    "about": "Mount Leaf Neem Face Wash is a gentle herbal cleanser made to purify the skin and control acne. Enriched with pure Neem extract, it removes dirt, excess oil and impurities while preventing pimples and breakouts. Its soothing formula keeps the skin fresh, clean and bacteria-free without drying it out. Ideal for oily, acne-prone and sensitive skin, this face wash leaves your skin clear, smooth and naturally glowing.",
    "benefits": [
      "Helps prevent acne & pimples",
      "Removes dirt, excess oil & impurities",
      "Keeps skin fresh & bacteria-free",
      "Soothes irritation & reduces redness",
      "Controls oil without drying",
      "Gives clear, smooth & glowing skin"
    ],
    "benefitDetails": [
      {
        "title": "Prevents Acne & Pimples",
        "text": "Neem Leaf Extract (5% w/w) and Tea Tree oil eliminate acne bacteria and stop breakouts before they start."
      },
      {
        "title": "Removes Dirt & Excess Oil",
        "text": "Thoroughly clarifies congested pores, dissolves sebum, and washes away pollution buildup."
      },
      {
        "title": "Keeps Skin Bacteria-Free",
        "text": "Tulsi and Green Tea extracts provide continuous antimicrobial protection and cellular defense."
      },
      {
        "title": "Soothes Irritation & Redness",
        "text": "Aloe Vera and Calendula calm inflammation and ease irritation on sensitive, acne-troubled skin."
      },
      {
        "title": "Controls Oil Without Dryness",
        "text": "Balances skin oil production without stripping natural moisture, leaving skin soft and supple."
      }
    ],
    "ingredients": [
      {
        "name": "Neem Leaf Extract (5% w/w)",
        "hindi": "नीम पत्ता अर्क",
        "local": "Azadirachta indica",
        "note": "Potent antimicrobial that cleanses impurities and prevents acne and pimples."
      },
      {
        "name": "Tulsi Leaf Extract (3% w/w)",
        "hindi": "तुलसी अर्क",
        "local": "Ocimum sanctum",
        "note": "Purifies skin, counters pollution, and keeps skin fresh and bacteria-free."
      },
      {
        "name": "Green Tea Extract (2.5% w/w)",
        "hindi": "हरी चाय अर्क",
        "local": "Camellia sinensis",
        "note": "Rich in polyphenols to balance excess oil and provide antioxidant protection."
      },
      {
        "name": "Aloe Vera Extract (2% w/w)",
        "hindi": "घृतकुमारी अर्क",
        "local": "Aloe barbadensis",
        "note": "Soothes irritation, calms redness, and hydrates without clogging pores."
      },
      {
        "name": "Ashwagandha Extract (1.5% w/w)",
        "hindi": "अश्वगंधा अर्क",
        "local": "Withania somnifera",
        "note": "Rejuvenates tired dermal cells and supports healthy skin recovery."
      },
      {
        "name": "Calendula Extract (1% w/w)",
        "hindi": "गेंदा फूल अर्क",
        "local": "Calendula officinalis",
        "note": "Calms sensitive and inflamed skin and promotes smooth healing."
      },
      {
        "name": "Tea Tree Oil (0.55% w/w)",
        "hindi": "चाय का पेड़ तेल",
        "local": "Melaleuca alternifolia",
        "note": "Natural antiseptic that controls sebum and unclogs pores."
      },
      {
        "name": "Turmeric & Mulethi (1% w/w)",
        "hindi": "हल्दी और मुलेठी",
        "local": "Curcuma longa & Licorice",
        "note": "Brightening duo that fades post-acne blemishes and promotes natural glow."
      }
    ],
    "steps": [
      "Wet your face with clean water.",
      "Take a small amount of face wash and gently massage it on your face.",
      "Make sure to cover forehead, nose, chin and cheeks with circular motions.",
      "Rinse thoroughly with water.",
      "Use twice daily for best results."
    ],
    "reviewsList": [
      {
        "name": "Muskan",
        "text": "Really good face wash. It feels gentle on the skin, cleanses well without making my face feel dry, and leaves the skin feeling fresh and soft. Definitely worth trying."
      },
      {
        "name": "Anjli",
        "text": "It cleans deeply but still feels mild. My skin stays fresh and clear throughout the day."
      },
      {
        "name": "Samriti Chanoria",
        "text": "Gentle on the skin and removes oil without drying."
      },
      {
        "name": "Pooja",
        "text": "After using this face wash for a few days, my skin feels smoother and more even."
      },
      {
        "name": "Harshita",
        "text": "Just a small amount cleans deeply and doesn't dry skin."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/neem-face-wash.png?v=1791907421"
  },
  {
    "id": "kanti-rasa-face-wash",
    "handle": "kanti-rasa-ayurvedic-skin-care-elixir-for-glowing-and-healthy-skin",
    "name": "Kanti Rasa Lightening & Brightening Face Wash",
    "tagline": "Radiance-boosting cleanser with Licorice, Saffron & Eladi oil",
    "category": "skin",
    "type": "Face wash",
    "concerns": [
      "dull-skin",
      "pigmentation",
      "tan"
    ],
    "badge": "Bestseller",
    "rating": 4.9,
    "reviews": 18,
    "ratingDist": [
      95,
      5,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "150 ml",
        "price": 499
      }
    ],
    "images": [
      "kanti-rasa",
      "kanti-rasa-3",
      "kanti-rasa-2",
      "kanti-rasa-4",
      "kanti-rasa-5"
    ],
    "short": "Gentle yet effective cleanser designed to brighten dull skin, lighten dark spots, remove tan, and revive a radiant illuminated look.",
    "about": "Mount Leaf Lightening & Brightening Face Wash is a gentle yet effective cleanser designed to brighten dull skin and even out skin tone. Enriched with natural brightening extracts, it helps lighten dark spots, remove tan, and revive tired-looking skin. Its soft, refreshing formula removes dirt, excess oil and impurities while keeping the skin hydrated and glowing. With regular use, it improves clarity, boosts radiance and gives your skin a fresh, illuminated look.",
    "benefits": [
      "Brightens dull & tired skin",
      "Helps lighten dark spots & pigmentation",
      "Removes tan & improves tone",
      "Cleanses dirt, oil & impurities",
      "Radiantly glowing skin",
      "Hydrated without dryness"
    ],
    "benefitDetails": [
      {
        "title": "Brightens Dull & Tired Skin",
        "text": "Revives fatigued complexion and restores a fresh, glowing, illuminated look with saffron and amla."
      },
      {
        "title": "Lightens Dark Spots & Pigmentation",
        "text": "Licorice Root Extract (5% w/w) and Bakuchi oil visibly target hyperpigmentation and fade spots."
      },
      {
        "title": "Removes Tan & Evens Skin Tone",
        "text": "Daruharidra and Vetiver gently lift sun tan and environmental dullness for an even complexion."
      },
      {
        "title": "Cleanses Without Dryness",
        "text": "Soft refreshing lather clears dirt and excess oil while Eladi oil seals in essential hydration."
      }
    ],
    "ingredients": [
      {
        "name": "Licorice Root Extract (5% w/w)",
        "hindi": "मुलेठी अर्क",
        "local": "Glycyrrhiza glabra",
        "note": "Potent botanical brightener that inhibits melanin to fade dark spots and even tone."
      },
      {
        "name": "Neem Leaf Extract (2.5% w/w)",
        "hindi": "नीम अर्क",
        "local": "Azadirachta indica",
        "note": "Purifies pores and keeps skin clear of bacteria and blemishes."
      },
      {
        "name": "Giloy & Green Tea (4% w/w)",
        "hindi": "गिलोय और ग्रीन टी",
        "local": "Tinospora & Camellia",
        "note": "Boosts skin immunity, balances oil, and defends against environmental pollution."
      },
      {
        "name": "Amla Fruit Extract (2% w/w)",
        "hindi": "आंवला अर्क",
        "local": "Emblica officinalis",
        "note": "High natural Vitamin C content that promotes skin clarity and youthful radiance."
      },
      {
        "name": "Daruharidra & Manjistha (3% w/w)",
        "hindi": "दारुहरिद्रा और मंजिष्ठा",
        "local": "Berberis & Rubia",
        "note": "Classical Ayurvedic duo for blood purification, tan removal, and blemish correction."
      },
      {
        "name": "Vetiver Root Extract (1.5% w/w)",
        "hindi": "खस / उशीर अर्क",
        "local": "Chrysopogon zizanioides",
        "note": "Cooling root extract that calms facial heat and refines skin texture."
      },
      {
        "name": "Eladi & Bakuchi Oil (1.5% w/w)",
        "hindi": "एलादि और बाकुची तेल",
        "local": "Classical botanical oils",
        "note": "Nourishing Ayurvedic oils that enhance skin texture and fade discolouration."
      },
      {
        "name": "Patchouli, Cardamom & Saffron",
        "hindi": "केसर, इलायची, पचौली",
        "local": "Crocus sativus & oils",
        "note": "Luxurious aromatic botanicals that impart an illuminated natural glow."
      }
    ],
    "steps": [
      "Wet your face with clean water.",
      "Take a small amount of face wash onto your wet palms.",
      "Massage gently on the face in circular motions for 30–60 seconds.",
      "Rinse well with clean water and pat dry.",
      "Use twice daily for best results."
    ],
    "reviewsList": [
      {
        "name": "Ritika",
        "text": "Leaves skin visibly brighter after each wash without feeling stretched or dry."
      },
      {
        "name": "Rohit Verma",
        "text": "Helped fade sun tan significantly in 2 weeks. Very refreshing aroma."
      },
      {
        "name": "Meenakshi",
        "text": "The combination of licorice and saffron gives an instant fresh glow."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/kanti-rasa-lightening-face-wash.png?v=1791907418"
  },
  {
    "id": "pre-shave-oil",
    "handle": "pre-shave-oil",
    "name": "Pre Shave Oil",
    "tagline": "Botanical cushion for zero razor burn, less irritation & smoother glide",
    "category": "men",
    "type": "Shaving",
    "concerns": [
      "razor-burn"
    ],
    "badge": "Save 15%",
    "rating": 5.0,
    "reviews": 11,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "30 ml",
        "price": 679,
        "mrp": 799
      }
    ],
    "images": [
      "pre-shave-oil-1",
      "pre-shave-oil-3",
      "pre-shave-oil-2",
      "pre-shave-oil-4",
      "pre-shave-oil-5"
    ],
    "short": "Botanical blend that softens the beard, moisturizes skin, and creates a protective barrier for a close, irritation-free shave.",
    "about": "Mount Leaf Pre Shave Oil is a nourishing botanical blend designed to prepare your skin for a smooth and comfortable shave. Its lightweight, lubricating formula softens the beard, moisturizes the skin, and creates a protective layer that helps the razor glide effortlessly. Enriched with soothing herbs and natural oils, it reduces irritation, razor burns, and cuts while keeping the skin calm and hydrated.",
    "benefits": [
      "Better Skin Tone",
      "Less Friction & Irritation",
      "Softens Beard Hair",
      "Prevents Cuts & Razor Burns",
      "Protects Sensitive Skin"
    ],
    "benefitDetails": [
      {
        "title": "Better Skin Tone",
        "text": "Nourishes the skin with saffron and sandalwood, making it look healthier and more even-toned."
      },
      {
        "title": "Less Friction & Irritation",
        "text": "Creates a smooth protective layer that reduces razor friction and prevents cuts, redness, and irritation."
      },
      {
        "title": "Softens Beard Hair",
        "text": "Makes beard hair softer and easier to shave, resulting in a smoother, closer, and more comfortable shave."
      },
      {
        "title": "No Greasy Residue",
        "text": "Absorbs cleanly and works seamlessly under your regular shaving foam, cream, gel, or soap."
      }
    ],
    "ingredients": [
      {
        "name": "Quad-Oil Lubricating Shield",
        "hindi": "तिल, बादाम, नारियल, जैतून",
        "local": "Sesame, Almond, Coconut & Olive (68g)",
        "note": "Nutritive base oils that cushion blade contact and soften coarse stubble without drag."
      },
      {
        "name": "Sandalwood",
        "hindi": "चंदन",
        "local": "Santalum album 4g",
        "note": "Soothes razor burn, calms post-shave heat, and leaves a subtle masculine aroma."
      },
      {
        "name": "Licorice",
        "hindi": "मुलेठी",
        "local": "4g",
        "note": "Calms sensitive skin, prevents redness, and minimizes dark post-shave marks."
      },
      {
        "name": "Ceylon Oak & Dyer’s Oak",
        "hindi": "ओक छाल",
        "local": "7g total",
        "note": "Natural botanical astringents that tighten pores and firm skin against nicks."
      },
      {
        "name": "Manjistha & Lac Resin",
        "hindi": "मंजिष्ठा और लाक्षा",
        "local": "6g total",
        "note": "Promotes rapid skin repair and prevents bacterial irritation under facial hair."
      },
      {
        "name": "Symplocos & Gopi Chandan",
        "hindi": "लोध्र और गोपी चंदन",
        "local": "6g total",
        "note": "Cools skin friction and supports an even, clarified complexion."
      },
      {
        "name": "Saffron",
        "hindi": "केसर",
        "local": "0.3g",
        "note": "Soothes razor sensitivity, reduces inflammation, and enhances skin tone."
      }
    ],
    "steps": [
      "Before shaving, wash your face with warm water to soften the hair.",
      "Apply a small amount of the pre-shave oil to your beard area and stubble down to the neck.",
      "Gently massage it into your skin to soften the hair and prepare the skin.",
      "This reduces friction and allows the razor to glide smoothly. After that, proceed with your regular shaving routine."
    ],
    "reviewsList": [
      {
        "name": "Deepak Sharma",
        "text": "Smooth shave every time, no more razor burns. Thank you."
      },
      {
        "name": "Gourav",
        "text": "I was doubtful at first, but this oil actually makes shaving faster and easier."
      },
      {
        "name": "Rajesh Singh",
        "text": "No more redness after shave, skin feels calm."
      },
      {
        "name": "Vinay Mankotia",
        "text": "Makes shaving super smooth, no cuts or irritation."
      },
      {
        "name": "Sanjeev",
        "text": "Makes my skin look brighter and healthier with regular use."
      }
    ],
    "image": "https://cdn.shopify.com/s/files/1/0940/5133/6484/t/9/assets/bright-beauty-oil.png?v=1791907412"
  },
  {
    "id": "keshaura-hair-serum",
    "handle": "keshaura-hair-serum",
    "name": "Mount Leaf Hair Serum",
    "tagline": "Dual scalp & length herbal serum with Rosemary, Hibiscus & Pea Sprout",
    "category": "hair",
    "type": "Hair serum",
    "concerns": [
      "hair-fall",
      "dry-scalp"
    ],
    "badge": "New Formulation",
    "rating": 5.0,
    "reviews": 16,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "50 ml",
        "price": 799,
        "mrp": 999
      }
    ],
    "images": [
      "keshaura-hair-serum-1",
      "keshaura-hair-serum-2",
      "keshaura-hair-serum-3",
      "keshaura-hair-serum-4"
    ],
    "short": "Lightweight herbal serum designed to care for both scalp and hair length, strengthening roots and smoothing texture without grease.",
    "about": "Mount Leaf Hair Serum is a lightweight, herbal formulation specially designed to care for both the scalp and hair length. Enriched with powerful Ayurvedic herbs and advanced botanical extracts, it nourishes the scalp, strengthens hair roots, and improves hair texture from root to tip. The non-greasy formula absorbs quickly, leaving hair smooth, healthy, and naturally shiny without weighing it down.",
    "benefits": [
      "Nourishes & revitalizes scalp",
      "Strengthens hair roots",
      "Supports healthy hair growth",
      "Smoothens dry & frizzy hair",
      "Adds natural shine & softness",
      "Prevents breakage & split ends"
    ],
    "benefitDetails": [
      {
        "title": "Nourishes & Revitalizes Scalp",
        "text": "Deeply feeds hair follicles with botanical kwaths, improving blood circulation and scalp vitality."
      },
      {
        "title": "Strengthens Roots & Reduces Fall",
        "text": "Pea Sprout Extract and Rosemary stimulate dormant roots, curbing hair fall caused by weak anchors."
      },
      {
        "title": "Smoothens Frizzy Hair Lengths",
        "text": "Instantly tames unruly frizz and flyaways, leaving lengths velvety soft and touchably smooth."
      },
      {
        "title": "Natural Shine Without Grease",
        "text": "Hibiscus and Amla seal the cuticles to reflect mirror-like natural shine with zero weight."
      },
      {
        "title": "Prevents Split Ends & Breakage",
        "text": "Methi and Shikakai supply plant proteins to shield hair tips from environmental breakage."
      }
    ],
    "ingredients": [
      {
        "name": "Hibiscus Flower Kwath (5% w/w)",
        "hindi": "गुड़हल क्वाथ",
        "local": "Hibiscus rosa-sinensis",
        "note": "Rich in amino acids and antioxidants that seal hair cuticles and impart deep luster."
      },
      {
        "name": "Jatamansi Root Kwath (4% w/w)",
        "hindi": "जटामांसी क्वाथ",
        "local": "Nardostachys jatamansi",
        "note": "Improves hair texture, soothes scalp stress, and boosts manageability."
      },
      {
        "name": "Shikakai & Methi Kwath (6% w/w)",
        "hindi": "शिकाकाई और मेथी",
        "local": "Acacia & Trigonella",
        "note": "Protects hair fibers against tensile breakage and prevents split ends."
      },
      {
        "name": "Amla & Brahmi Kwath (5% w/w)",
        "hindi": "आंवला और ब्राह्मी",
        "local": "Emblica & Bacopa",
        "note": "Fortifies hair roots and revives natural hair bounce and volume."
      },
      {
        "name": "Aloe Vera Leaf Extract (2.5% w/w)",
        "hindi": "घृतकुमारी अर्क",
        "local": "Aloe barbadensis",
        "note": "Provides lightweight hydration and silky detangling slip with zero silicone."
      },
      {
        "name": "Rosemary Kwath & Oil (2.5% w/w)",
        "hindi": "रोज़मेरी क्वाथ और तेल",
        "local": "Rosmarinus officinalis",
        "note": "Clinically proven herbal active that boosts micro-circulation for stronger root anchors."
      },
      {
        "name": "Pea Sprout Extract (0.5% w/w)",
        "hindi": "मटर अंकुर अर्क",
        "local": "Pisum sativum L",
        "note": "Advanced botanical active that re-initiates the hair growth cycle and reactivates dormant roots."
      }
    ],
    "steps": [
      "For Scalp Care: Take 2–3 drops and gently massage onto your scalp. Leave it on.",
      "For Hair Length Care: Apply 1–2 drops evenly on mid-lengths and ends of clean, dry or damp hair.",
      "Do not rinse. Suitable for daily use before styling or after washing."
    ],
    "reviewsList": [
      {
        "name": "Divya Sharma",
        "text": "This serum is magic! It is completely non-sticky and took away all the frizz from my hair on the very first day."
      },
      {
        "name": "Meera",
        "text": "I love that I can apply it on both scalp and ends. My roots feel stronger and hair looks shiny."
      },
      {
        "name": "Pooja",
        "text": "Lightweight, absorbs instantly and smells refreshing. Best natural hair serum I've tried."
      }
    ],
    "image": "keshaura-serum.webp"
  },
  {
    "id": "body-massage-oil",
    "handle": "kesh-vapan-hair-oil",
    "name": "Mount Leaf Body Massage Oil",
    "tagline": "Traditional Ayurvedic rejuvenation oil with Ashwagandha, Shatavari & Til oil",
    "category": "men",
    "forMen": true,
    "type": "Body oil",
    "concerns": [
      "body-fatigue"
    ],
    "badge": "Ayurvedic Classic",
    "rating": 5.0,
    "reviews": 14,
    "ratingDist": [
      100,
      0,
      0,
      0,
      0
    ],
    "sizes": [
      {
        "label": "100 ml",
        "price": 895,
        "mrp": 1099
      }
    ],
    "images": [
      "kesh-vapan-hair-oil-1",
      "prabal-hair-oil-1",
      "product-lifestyle"
    ],
    "short": "Traditional Ayurvedic formulation enriched with Ashwagandha, Shatavari, Brahmi, and pure Til oil to relax tired muscles and rejuvenate the body.",
    "about": "Mount Leaf Body Massage Oil is a traditional Ayurvedic formulation enriched with powerful herbs like Ashwagandha, Shatavari, Brahmi, Jatamansi, and pure Til (Sesame) Oil, processed with cow milk. This deeply nourishing oil helps relax tired muscles, strengthen nerves, improve blood circulation, and rejuvenate the body. Regular massage with this oil promotes overall wellness, reduces stress, and provides natural energy to the body.",
    "benefits": [
      "Relieves muscle pain & body fatigue",
      "Reduces stress & mental tiredness",
      "Strengthens nerves and muscles",
      "Improves blood circulation",
      "Nourishes skin & prevents dryness",
      "Ideal for daily massage & spa use"
    ],
    "benefitDetails": [
      {
        "title": "Relieves Muscle Pain & Stiffness",
        "text": "Eases aching joints, muscle stiffness, and physical fatigue through warming herbal penetrative massage."
      },
      {
        "title": "Strengthens Nerves & Muscles",
        "text": "Classical Ashwagandha and Shatavari cooked in cow milk nourish and fortify deep body tissues (Dhatus)."
      },
      {
        "title": "Reduces Stress & Anxiety",
        "text": "Brahmi and Jatamansi soothe the nervous system, bringing tranquil calm and restful sleep."
      },
      {
        "title": "Improves Blood Circulation",
        "text": "Stimulates lymphatic drainage and vitalizes micro-circulation across limbs and joints."
      },
      {
        "title": "Deeply Nourishes Dry Skin",
        "text": "Pure cold-pressed sesame oil restores epidermal moisture, preventing flaking and dryness."
      }
    ],
    "ingredients": [
      {
        "name": "Til Oil (Sesame Seed Oil)",
        "hindi": "तिल तेल 100ml",
        "local": "Sesamum Indicum",
        "note": "Classical penetrating Ayurvedic base oil that transports herbal actives into deep muscle tissues."
      },
      {
        "name": "Cow Milk (Lactis)",
        "hindi": "गोदुग्ध 400ml",
        "local": "Fresh Cow Milk",
        "note": "Processed through authentic Kshirapak method to impart profound vitality and muscular strength."
      },
      {
        "name": "Ashwagandha",
        "hindi": "अश्वगंधा 0.4g",
        "local": "Withania somnifera",
        "note": "Supreme adaptogen that relieves muscle fatigue, strengthens nerves, and restores energy."
      },
      {
        "name": "Shatavari",
        "hindi": "शतावरी 0.4g",
        "local": "Asparagus racemosus",
        "note": "Nutritive rasayana herb that revitalizes tired tissues and supports physical recovery."
      },
      {
        "name": "Kuth (Saussurea costus)",
        "hindi": "कुठ 0.4g",
        "local": "Indian costus",
        "note": "Anti-inflammatory botanical that alleviates joint stiffness and muscular soreness."
      },
      {
        "name": "Jatamansi",
        "hindi": "जटामांसी 0.4g",
        "local": "Nardostachys jatamansi",
        "note": "Calms mental anxiety, relieves chronic stress, and induces serene relaxation."
      },
      {
        "name": "Brahmi",
        "hindi": "ब्राह्मी 0.4g",
        "local": "Bacopa monnieri",
        "note": "Soothes nervous tension, improves blood circulation, and promotes overall wellness."
      },
      {
        "name": "Keteli",
        "hindi": "कटेली 0.4g",
        "local": "Solanum torvum",
        "note": "Traditional herb that eases muscular tightness, aches, and spasms."
      }
    ],
    "steps": [
      "Take the required quantity of Mount Leaf Body Massage Oil in a small bowl.",
      "Slightly warm the oil by placing the bowl in warm water for better absorption.",
      "Gently massage all over the body using circular motions on joints and long strokes on limbs.",
      "Leave it on for 20–30 minutes to let the herbs penetrate deeply.",
      "Take a warm bath or steam for best results. Use daily or at least 3–4 times a week."
    ],
    "reviewsList": [
      {
        "name": "Vikram Singh",
        "text": "Relieves body aches and tired muscles after a long day of work. You sleep so peacefully after massage."
      },
      {
        "name": "Sunita Verma",
        "text": "Very soothing, genuine Ayurvedic smell and warms the muscles nicely. Great for joint stiffness."
      },
      {
        "name": "Rajesh Kumar",
        "text": "Best oil for Panchkarma and self-abhyanga. Skin stays hydrated and body feels energized."
      }
    ],
    "image": "kesh-vapan-hair-oil-1.webp"
  }
];

var BUNDLE_DISCOUNT = 0.10;
const BUNDLES = [
  {
    "id": "hair-fall-kit",
    "name": "Hair Fall Kit",
    "tagline": "Oil, scalp treatment and shampoo for stronger roots",
    "concern": "hair-fall",
    "items": [
      "sprouting-hair-oil",
      "bio-hair-enzyme",
      "sprouting-shampoo"
    ]
  },
  {
    "id": "hemp-smooth-kit",
    "name": "Hemp Smooth Hair Kit",
    "tagline": "Deep scalp enzyme and frizz-control hemp shampoo",
    "concern": "hair-fall",
    "items": [
      "bio-hair-enzyme",
      "velvet-touch-hemp-shampoo"
    ]
  },
  {
    "id": "glow-kit",
    "name": "Everyday Glow Kit",
    "tagline": "Cleanse, polish and nourish for brighter skin",
    "concern": "dull-skin",
    "items": [
      "kanti-rasa-face-wash",
      "replenishing-face-pack",
      "bright-beauty-oil"
    ]
  },
  {
    "id": "clear-skin-kit",
    "name": "Clear Skin Kit",
    "tagline": "For oily, acne-prone skin",
    "concern": "acne",
    "items": [
      "prakleen-neem-face-wash",
      "replenishing-face-pack"
    ]
  },
  {
    "id": "spot-care-kit",
    "name": "Dark Spot Care Kit",
    "tagline": "Day cream and night oil for an even tone",
    "concern": "pigmentation",
    "items": [
      "radiance-cream",
      "bright-beauty-oil"
    ]
  },
  {
    "id": "shave-kit",
    "name": "Men's Shave Kit",
    "tagline": "Clean skin and a smoother, calmer shave",
    "concern": "razor-burn",
    "items": [
      "prakleen-neem-face-wash",
      "pre-shave-oil"
    ]
  }
];

const ROUTINES = {
  "skin": {
    "label": "Skin",
    "intro": "A simple four-step routine for brighter, clearer skin.",
    "steps": [
      {
        "name": "Cleanse",
        "when": "Morning & night",
        "times": [
          "am",
          "pm"
        ],
        "why": "Removes oil, dirt and sunscreen without drying.",
        "options": [
          {
            "id": "kanti-rasa-face-wash",
            "hint": "For dull skin"
          },
          {
            "id": "prakleen-neem-face-wash",
            "hint": "For oily, acne-prone skin"
          }
        ]
      },
      {
        "name": "Exfoliate",
        "when": "2–3 times a week",
        "days": [
          0,
          3
        ],
        "times": [
          "pm"
        ],
        "why": "Clears dead skin so the next steps work better.",
        "options": [
          {
            "id": "replenishing-face-pack"
          }
        ]
      },
      {
        "name": "Moisturise",
        "when": "Every morning",
        "times": [
          "am"
        ],
        "why": "Keeps skin hydrated and evens tone through the day.",
        "options": [
          {
            "id": "radiance-cream"
          }
        ]
      },
      {
        "name": "Night oil",
        "when": "Every night",
        "times": [
          "pm"
        ],
        "why": "Nourishes and brightens while your skin repairs overnight.",
        "options": [
          {
            "id": "bright-beauty-oil"
          }
        ]
      }
    ]
  },
  "hair": {
    "label": "Hair",
    "intro": "Three steps for a healthy scalp and less hair fall.",
    "steps": [
      {
        "name": "Oil",
        "when": "Night before you wash",
        "days": [
          0,
          3
        ],
        "times": [
          "pm"
        ],
        "why": "Feeds the roots and protects lengths before washing.",
        "options": [
          {
            "id": "sprouting-hair-oil"
          }
        ]
      },
      {
        "name": "Scalp treatment",
        "when": "An hour before washing",
        "days": [
          1,
          4
        ],
        "times": [
          "am"
        ],
        "why": "Deep-cleans the scalp and targets hair fall at the root.",
        "options": [
          {
            "id": "bio-hair-enzyme"
          }
        ]
      },
      {
        "name": "Wash",
        "when": "2–3 times a week",
        "days": [
          1,
          4
        ],
        "times": [
          "am"
        ],
        "why": "Cleans gently without stripping natural oils.",
        "options": [
          {
            "id": "sprouting-shampoo",
            "hint": "Ayurvedic growth wash"
          },
          {
            "id": "velvet-touch-hemp-shampoo",
            "hint": "Frizz-control smoothing"
          }
        ]
      }
    ]
  },
  "men": {
    "label": "Men",
    "intro": "Clean skin and a smoother shave, in two steps.",
    "steps": [
      {
        "name": "Cleanse",
        "when": "Morning & night",
        "times": [
          "am",
          "pm"
        ],
        "why": "Removes oil, dirt and sunscreen without drying.",
        "options": [
          {
            "id": "prakleen-neem-face-wash",
            "hint": "For oily skin"
          },
          {
            "id": "kanti-rasa-face-wash",
            "hint": "For dull skin"
          }
        ]
      },
      {
        "name": "Before shaving",
        "when": "Every shave",
        "days": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "times": [
          "am"
        ],
        "why": "Softens the beard for a smoother, calmer shave.",
        "options": [
          {
            "id": "pre-shave-oil"
          }
        ]
      }
    ]
  }
};

const INGREDIENTS = [
  {
    "key": "Saffron",
    "hindi": "केसर",
    "local": "Kesar",
    "about": "One of the most prized herbs in Ayurveda. Used for centuries to brighten the skin, fade pigmentation, and provide antioxidant vitality."
  },
  {
    "key": "Neem",
    "hindi": "नीम",
    "local": "Neem",
    "about": "Ayurveda's most famous purifier. Antibacterial and antifungal, it clears acne, controls excess oil, and frees scalp from dandruff."
  },
  {
    "key": "Amla",
    "hindi": "आंवला",
    "local": "Indian gooseberry",
    "about": "Rich in natural vitamin C. Used in hair care for root strength and shine, and in skin care for youthful radiance."
  },
  {
    "key": "Sandalwood",
    "hindi": "चंदन",
    "local": "Chandan",
    "about": "Cooling and calming. Traditionally used to soothe heat, redness, and razor burn while imparting natural glow."
  },
  {
    "key": "Turmeric",
    "hindi": "हल्दी",
    "local": "Haldi",
    "about": "A classic ubtan botanical. Helps brighten dull skin, fade dark spots, and cleanse the scalp."
  },
  {
    "key": "Aloe vera",
    "hindi": "घृतकुमारी",
    "local": "Ghritkumari",
    "about": "Hydrates, soothes, and cools. Balances potent herbs so skin and scalp never feel dry."
  },
  {
    "key": "Licorice",
    "hindi": "मुलेठी",
    "local": "Mulethi",
    "about": "Celebrated skin brightener. Inhibits excess melanin to fade dark spots, marks, and uneven tone over time."
  },
  {
    "key": "Reetha",
    "hindi": "रीठा",
    "local": "Soapnut",
    "about": "A natural cleanser that cleanses scalp and hair gently without stripping essential natural sebum."
  },
  {
    "key": "Hemp Seed Oil",
    "hindi": "भांग बीज तेल",
    "local": "Cold-pressed",
    "about": "Packed with Omega 3, 6, and 9 lipids to smooth hair cuticles, tame stubborn frizz, and retain deep moisture."
  },
  {
    "key": "Tea extract",
    "hindi": "चाय सत्व",
    "local": "CSIR-IHBT researched",
    "about": "Himalayan green tea polyphenols with high antioxidant and natural antimicrobial activity."
  }
];

const PRODUCT_EDU = {
  "bright-beauty-oil": {
    "who": "All skin types. Especially beneficial for dullness, dark spots, uneven skin tone, fine lines, and dehydration.",
    "when": "Night ritual only. Apply 2–3 drops after cleansing before bedtime.",
    "expect": "Velvety soft, deeply nourished skin the next morning. Visibly brighter tone and faded spots over 2–4 weeks."
  },
  "replenishing-face-pack": {
    "who": "All skin types, especially sun-tanned, congested, or dull-looking skin.",
    "when": "Once a week as a detox and rejuvenation ritual.",
    "expect": "Instantly smooth, clean, and radiant skin after the first use. Stubborn tan lifts gradually over 3–4 weeks."
  },
  "bio-hair-enzyme": {
    "who": "All hair types. Perfect for weak roots, thinning hair, dry scalp, or dandruff.",
    "when": "Apply directly to roots before bedtime. Leave on overnight.",
    "expect": "Fresh, hydrated scalp immediately. Noticeably stronger roots and reduced hair fall within 3–4 weeks."
  },
  "velvet-touch-hemp-shampoo": {
    "who": "Frizzy, dry, unmanageable hair, or anyone wanting sulfate-free smoothing.",
    "when": "2–3 times weekly. Pairs with Hair Enzyme.",
    "expect": "Touchably smooth, frizz-free hair from the first wash."
  },
  "hand-rub": {
    "who": "Everyone needing gentle, high-efficacy hand hygiene.",
    "when": "Whenever sanitization is required.",
    "expect": "Clean hands without dry, cracked skin."
  },
  "sprouting-hair-oil": {
    "who": "All hair types. Ideal for hair thinning, premature greying, dry scalp, and weak roots.",
    "when": "Three times a week consistently for eight weeks. Apply 30 min before wash or leave overnight.",
    "expect": "Conditioned, softer hair from the first wash. Measurable decrease in hair fall and flakes over 3–4 weeks."
  },
  "sprouting-shampoo": {
    "who": "All hair types. Everyday or alternate-day cleanser for dandruff control and hair fall reduction.",
    "when": "Every wash day (2–3 times a week). Pairs with Sprouting Bio Hair Enzyme.",
    "expect": "Deeply clean scalp without stripped dryness. Noticeable dandruff and fall control within 2–3 weeks."
  },
  "radiance-cream": {
    "who": "All skin types. Ideal for blemishes, dark spots, dark circles, freckles, and fine lines.",
    "when": "Daily use, morning and night (especially recommended at bedtime).",
    "expect": "Hydrated, supple skin immediately. Visible fading of spots, freckles, and fine lines within 2–4 weeks."
  },
  "prakleen-neem-face-wash": {
    "who": "Oily, acne-prone, and sensitive skin types dealing with pimples, blemishes, and excess oil.",
    "when": "Twice daily, morning and night.",
    "expect": "Immediate control over oily shine. Noticeably clearer skin with fewer breakouts in 2–3 weeks."
  },
  "kanti-rasa-face-wash": {
    "who": "All skin types looking to treat dullness, sun tan, and pigmentation.",
    "when": "Twice daily, morning and night.",
    "expect": "Fresh, radiant glow after every wash. Noticeably brighter tone and spot reduction over 3–4 weeks."
  },
  "pre-shave-oil": {
    "who": "Men of all skin types who shave regularly, especially those prone to razor burn, cuts, or irritation.",
    "when": "Before every shave on damp skin.",
    "expect": "Zero drag, smooth blade glide, and completely calm, burn-free skin from the first shave."
  },
  "keshaura-hair-serum": {
    "who": "All hair types. Perfect for frizzy, weak, or tangled hair needing scalp nourishment and silky lengths.",
    "when": "Daily on clean damp or dry hair. Leave-in formulation.",
    "expect": "Instant frizz control and silky softness. Noticeably denser, stronger hair with regular scalp application."
  },
  "body-massage-oil": {
    "who": "Men & women of all skin types. Ideal for body pain, joint stiffness, physical fatigue, stress, and professional spa/Panchkarma use.",
    "when": "Daily or 3–4 times a week before warm bath or steam.",
    "expect": "Immediate feeling of deep physical relaxation and relief from tightness. Supple skin and rejuvenated energy."
  }
};

const ROLES = {
  "Saffron": "Brightening active",
  "Sandalwood": "Soothing active",
  "Red sandalwood": "Brightening active",
  "Coconut oil": "Base oil",
  "Almond oil": "Nourishing base oil",
  "Turmeric": "Clarifying active",
  "Onion seeds": "Gentle exfoliant",
  "Nutgrass": "Tone-evening active",
  "Reetha": "Natural cleanser",
  "Amla": "Strengthening active",
  "Aloe vera": "Soother & hydrator",
  "Bhringraj": "Hair-growth herb",
  "Brahmi": "Scalp-calming herb",
  "Sesame oil": "Base oil",
  "Shikakai": "Natural cleanser",
  "Licorice root": "Spot-fading active",
  "Licorice": "Spot-fading active",
  "Neem": "Purifying active",
  "Tulsi": "Purifying herb",
  "Ashwagandha": "Revitalising herb",
  "Giloy": "Protective herb",
  "Green tea": "Oil-balancing active",
  "Manjistha": "Anti-blemish herb",
  "Mulethi": "Spot-fading active",
  "Camphor": "Cooling agent",
  "Gorochana": "Traditional revitaliser",
  "Bay leaf": "Aromatic herb",
  "Kaner patta": "Scalp balancer",
  "Jaggery": "Natural humectant",
  "Chironji": "Nourishing seed",
  "Sprouted botanicals": "Root nourisher",
  "Gentle cleansers": "Mild cleanser",
  "Hemp Seed Oil": "Cuticle-smoothing lipid",
  "Tea extract": "Antimicrobial antioxidant",
  "Essential oils": "Natural antiseptic"
};

ML_SEED.forEach(p => {
  Object.assign(p, PRODUCT_EDU[p.id] || {});
  (p.ingredients || []).forEach(i => { i.role = ROLES[i.name] || 'Key ingredient'; });
});

var CONCERNS = {
  'pigmentation': 'Dark spots & pigmentation',
  'dull-skin': 'Dull, uneven skin',
  'tan': 'Sun tan',
  'acne': 'Acne & breakouts',
  'oily-skin': 'Oily skin',
  'fine-lines': 'Fine lines',
  'hair-fall': 'Hair fall & thinning',
  'dandruff': 'Dandruff',
  'dry-scalp': 'Dry scalp',
  'razor-burn': 'Razor burn',
  'body-fatigue': 'Body fatigue'
};

var CATEGORIES = {
  'skin': 'Skin care',
  'hair': 'Hair care',
  'men': 'Men'
};

const CONCERN_INFO = {
  'pigmentation': { title: 'Dark spots & pigmentation', intro: 'Spots from sun, acne marks or hormones fade slowly. What helps: a gentle cleanser, a brightening night oil and patience. Most people see a difference over 6–8 weeks.', steps: 'Cleanse → Night oil → Day cream' },
  'acne': { title: 'Acne & breakouts', intro: 'Breakouts usually come from excess oil and clogged pores. Cleanse twice a day, exfoliate gently a couple of times a week, and don\'t over-scrub.', steps: 'Neem wash → Face pack twice a week' },
  'tan': { title: 'Sun tan', intro: 'Tan sits in the top layers of skin. Gentle, regular exfoliation lifts it faster than harsh scrubs, and a nourishing oil keeps skin even while it fades.', steps: 'Face pack 2–3×/week → Night oil' },
  'dull-skin': { title: 'Dull, tired skin', intro: 'Dullness is often a build-up of dead skin and dehydration. Clean gently, polish once or twice a week and nourish at night.', steps: 'Brightening wash → Face pack → Night oil' },
  'hair-fall': { title: 'Hair fall & thinning', intro: 'A clean, well-fed scalp is where stronger hair starts. Treat the scalp before washing, use a mild shampoo and oil the roots a few times a week. Expect changes over 6–8 weeks.', steps: 'Oil → Scalp treatment → Mild shampoo' },
  'dandruff': { title: 'Dandruff', intro: 'Flakes come from an irritated, oily scalp. Deep-clean the scalp a few times a week and switch to a gentle herbal shampoo that doesn\'t strip it.', steps: 'Scalp treatment → Herbal shampoo' }
};

const ING_COLORS = {
  'Saffron': '#C8642E', 'Neem': '#5B7F3A', 'Amla': '#9DB548', 'Sandalwood': '#C59A52',
  'Turmeric': '#D9A21B', 'Aloe vera': '#7DAF6B', 'Licorice': '#8A5A3A', 'Reetha': '#A0784A',
  'Hemp Seed Oil': '#4B7332', 'Tea extract': '#2E5A27'
};

const INGREDIENT_META = {
  'Saffron': { latin: 'Crocus sativus', part: 'Stigma', goodFor: ['dull-skin', 'pigmentation'] },
  'Neem': { latin: 'Azadirachta indica', part: 'Leaf', goodFor: ['acne', 'oily-skin', 'dandruff'] },
  'Amla': { latin: 'Phyllanthus emblica', part: 'Fruit', goodFor: ['hair-fall', 'dull-skin'] },
  'Sandalwood': { latin: 'Santalum album', part: 'Heartwood', goodFor: ['dull-skin', 'razor-burn'] },
  'Turmeric': { latin: 'Curcuma longa', part: 'Rhizome', goodFor: ['acne', 'tan', 'dull-skin'] },
  'Aloe vera': { latin: 'Aloe barbadensis', part: 'Leaf gel', goodFor: ['acne', 'dandruff', 'razor-burn'] },
  'Licorice': { latin: 'Glycyrrhiza glabra', part: 'Root', goodFor: ['pigmentation', 'dull-skin'] },
  'Reetha': { latin: 'Sapindus mukorossi', part: 'Fruit (soapnut)', goodFor: ['dandruff', 'hair-fall'] },
  'Hemp Seed Oil': { latin: 'Cannabis sativa seed', part: 'Cold-pressed seed oil', goodFor: ['dry-scalp', 'hair-fall'] },
  'Tea extract': { latin: 'Camellia sinensis', part: 'Leaf polyphenols', goodFor: ['dry-skin'] }
};
INGREDIENTS.forEach(i => Object.assign(i, INGREDIENT_META[i.key] || {}));

const INGREDIENT_ALIASES = { 'Licorice': ['licorice', 'mulethi'], 'Sandalwood': ['sandalwood'] };
const ingredientMatches = (key, name) => {
  const n = name.toLowerCase();
  return (INGREDIENT_ALIASES[key] || [key.toLowerCase()]).some(a => n === a || n.startsWith(a + ' '));
};
